import { useSelector } from "react-redux";
import { t } from "i18next";
import { resolveSignedByDisplayName } from "Utils/Requisition/resolveSignedByDisplayName";

function getSiblingFieldValue(
  fieldData: unknown,
  systemFieldName: string
): string {
  if (!Array.isArray(fieldData)) return "";
  const row = fieldData.find(
    (x: { systemFieldName?: string }) => x?.systemFieldName === systemFieldName
  );
  if (!row || row.fieldValue === null || row.fieldValue === undefined)
    return "";
  return String(row.fieldValue).trim();
}

function signatureImgSrc(fieldValue: unknown): string {
  if (fieldValue === null || fieldValue === undefined) return "";
  const raw = String(fieldValue);
  if (
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("data:")
  ) {
    return raw;
  }
  if (raw.includes("data:image/png;base64,")) {
    return raw;
  }
  return `data:image/png;base64,${raw}`;
}

const SignatureText = (props: any) => {
  const user = useSelector((state: any) => state?.Reducer);
  const { fieldsInfo, fieldData } = props;
  if (
    fieldsInfo.fieldValue.includes("https://truemedpo.blob.core.windows.net") ||
    fieldsInfo.fieldValue.includes("data:image/png;base64")
  ) {
    const isPhysician = fieldsInfo.systemFieldName === "PhysicianSignature";
    const providerName = resolveSignedByDisplayName(
      getSiblingFieldValue(fieldData, "SignedBy"),
      fieldData
    );
    const sigDate = getSiblingFieldValue(fieldData, "PhysicianDate");
    const sigTime = getSiblingFieldValue(fieldData, "PhysicianTime");
    const showElectronicLine =
      isPhysician && (providerName !== "" || sigDate !== "" || sigTime !== "");
    const imgSrc = isPhysician
      ? signatureImgSrc(fieldsInfo?.fieldValue)
      : fieldsInfo?.fieldValue;
    return (
      <>
        <img src={imgSrc} alt={user?.selectedTenantInfo?.name} />
        {showElectronicLine ? (
          <p className="mt-2 mb-0">
            {t("Signed by")}{" "}
            <strong className="fw-semibold text-body">
              {providerName || "—"}
            </strong>{" "}
            {t("on")}{" "}
            <strong className="fw-bold text-body">{sigDate || "—"}</strong>{" "}
            {t("and")}{" "}
            <strong className="fw-bold text-body">{sigTime || "—"}</strong>.
          </p>
        ) : null}
      </>
    );
  } else return null;
};

export default SignatureText;
